// API payload shapes — mirrors the FastAPI backend contract.

export type ListName = "queue" | "watchlist" | "watched" | "ignore";

export const LIST_NAMES: readonly ListName[] = ["queue", "watchlist", "watched", "ignore"];

/** GET /api/lists */
export type ListCounts = Record<ListName, { count: number }>;

/** One row of GET /api/lists/{name} */
export interface ListItem {
  imdb_id: string;
  title: string;
  title_type: string;
  year: number | null;
  genres: string[] | string | null;
  runtime_minutes: number | null;
  rating: number | null;
  listed_at: string | null;
  has_cover: boolean;
}

export interface ListItemsResponse {
  items: ListItem[];
}

/** GET /api/titles/{imdb_id} + POST /api/titles/{imdb_id}/rate response */
export interface TitleDetail {
  imdb_id: string;
  title: string;
  title_type: string;
  year: number | null;
  runtime_minutes: number | null;
  genres: string[];
  director: string | null;
  cast: string[];
  synopsis: string | null;
  rating: number | null;
  list: ListName | null;
  has_cover: boolean;
}

/** GET /api/analyze/status */
export type AnalyzeState = "idle" | "running" | "done" | "error";
export type AnalyzePhase = "profile" | "claude" | "matching" | "enriching" | null;

export interface AnalyzeStatus {
  state: AnalyzeState;
  phase: AnalyzePhase;
  progress: { done: number; total: number } | null;
  added: number | null;
  error: string | null;
  started_at: string | null;
  finished_at: string | null;
}

/** One row of GET /api/stats/queues — a presented queue (batch). */
export interface QueueStat {
  seq: number;
  created_at: string;
  size: number;
  pending: number;
  complete: boolean;
  watched: number;
  unrated: number;
  rating_counts: Record<number, number>;
  avg_rating: number | null;
}

export interface QueueStatsResponse {
  queues: QueueStat[];
}

/** Rating scale 1–9 → label. 0 is contextual: "not watched" — skip
 * (queue/watchlist) or unrate (watched). */
export const RATING_LABELS: Record<number, string> = {
  1: "endured",
  2: "watched",
  3: "enjoyed",
  4: "memorable",
  5: "recommend",
  6: "timeless",
  7: "home",
  8: "—",
  9: "immortal",
};
